<template>
    <div class="fidelity-card-component">
        <!-- Template content goes here -->
        <!--<h2>Cashback Olga</h2>-->
        <div class="content-container">
            <div class="info-container">
                <div class="info-item" v-html="buildCashbackMessage()"></div>
                <div class="applied-coupon-container">
                    <div class="applied-coupon-item" v-for="(gift, key) in giftsApplied" :key="key">
                        <span>{{ getGiftCode(gift) }}</span>
                        <button @click="removeCoupon(gift.key)"></button>
                    </div>
                </div>
                <div class="message-container" v-if="message">{{ message }}</div>
            </div>
            <div class="resume-container">
                <div class="resume-item"><span>{{getString('total_do_pedido')}}</span> <span>{{ formatMoney(saleValue) }}</span></div>
                <div class="resume-item" :class="{ 'green': valueDiscount > 0 }"><span>{{getString('valor_do_desconto')}}</span> <span>{{ getValueDiscount() }}</span></div>
                <div class="resume-item" v-if="(valueCashback > 0) || cahsbackAccumulated" :class="{ 'red': !phone, 'green': phone }">
                    <span v-text="cahsbackAccumulated ? getString('cashback') : getString('valor_do_cashback')"></span>
                    <span v-text="(phone && !cahsbackAccumulated) || (!phone && !cahsbackAccumulated) ? formatMoney(valueCashback) : valueCashback"></span>
                </div>
                <div class="resume-item"><span>{{getString('total_a_pagar')}}</span>
                    <span>{{ formatMoney(saleValue - valueDiscount) }}</span>
                </div>
            </div>
        </div>
        <div class="button-container">
            <DefaultButton v-for="(btn, key) in buttons.filter(btn => btn.visible)" :key="key" :text="btn.text + (couponsAvailable.length > 0 ? ` (${couponsAvailable.length})` : '')"
                :icon="btn.icon" @defaultBtnClick="btn['action']()" :imageRight="true">
            </DefaultButton>
        </div>
        <div class="overlay" v-if="showIdentificationModal"></div>
        <IdentificationModal v-if="showIdentificationModal" @close="closeIdentificationModal"></IdentificationModal>
        <CoupomCodeModal v-if="showCoupomCodeModal" :saleValue="saleValue" @closeCoupomCodeModal="closeCoupomCodeModal"
            @selectGift="selectGift" :phone.sync="phone"></CoupomCodeModal>
        <div class="overlay" v-if="loadingCrmFixe">
            <div class="loading-modal">
                <Loader :loading="!crmFixeFinished" :finish="crmFixeFinished" />
                <span class="loading-text">{{ getString('aguarde') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton.vue'
import IdentificationModal from '@/components/IdentificationModal.vue'
import CoupomCodeModal from '@/components/FidelityComponents/CoupomCodeModal.vue'
import Loader from '@/components/Loader.vue'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import CartController from '@/assets/controllers/CartController'
import Util from '@/assets/libs/util'
import LocaleController from '@/assets/controllers/LocaleController'
import eventModule from '@/assets/libs/eventModule'
export default {
    name: 'FidelityCardComponent',
    components: {
        DefaultButton,
        IdentificationModal,
        CoupomCodeModal,
        Loader
    },
    props: [],
    data () {
        return {
            showIdentificationModal: false,
            showCoupomCodeModal: false,
            buttons: [
                {
                    text: this.getString('quero_ganhar_cashback'),
                    action: this.receiveCashback,
                    icon: require('../../../static/icons/casbackIcon.png'),
                    visible: true
                },
                {
                    text: this.getString('utilizar_cupom'),
                    action: this.useCoupon,
                    icon: require('../../../static/icons/cupom-de-desconto.png'),
                    visible: false
                },
                {
                    text: this.getString('limpar_dados_cashback'),
                    action: this.clearData,
                    visible: false
                }
            ],
            cashbackCampaign: null,
            cashbackCampaignParams: null,
            saleValue: CartController.getTotalPriceAsFloat(true, false),
            valueCashback: 0,
            valueDiscount: 0,
            cart: CartController.getCart(),
            phone: CashbackCampaingController.getPhone(),
            documentNumber: CashbackCampaingController.getDocumentNumber(),
            giftDiscountType: '',
            giftAmount: 0,
            giftType: '',
            giftsApplied: CashbackCampaingController.getGiftApplied(),
            message: '',
            couponsAvailable: [],
            cahsbackAccumulated: false,
            crmFixeResume: null,
            crmFixeClientMessage: null,
            loadingCrmFixe: false,
            crmFixeFinished: false
        }
    },
    computed: {},
    methods: {
        receiveCashback: function () {
            this.openIdentificationModal()
        },
        useCoupon: function () {
            this.openCoupomCodeModal()
        },
        clearData: function (skipEmit = false) {
            CashbackCampaingController.clearData()
            this.phone = ''
            this.documentNumber = ''
            this.giftDiscountType = ''
            this.giftAmount = 0
            this.giftType = ''
            this.giftsApplied = []
            this.message = ''
            this.couponsAvailable = []
            this.cahsbackAccumulated = false
            this.valueDiscount = 0
            this.buttons[0].visible = false
            this.buttons[1].visible = false
            this.buttons[2].visible = false
            this.idCliValue = ''
            this.calculateGiftValue()
            if (!skipEmit) {
                this.$emit('setIdCliValue', '')
            }
            this.crmFixeClientMessage = null
            this.crmFixeResume = null
            this.loadingCrmFixe = false
            this.crmFixeFinished = false
            // aqui deve tirar o calulo do cashback e do desc
            this.$forceUpdate()
        },
        openIdentificationModal: function () {
            this.showIdentificationModal = true
        },
        closeIdentificationModal: function () {
            this.showIdentificationModal = false
            if (this.cashbackCampaign.campaignEnabled === 4) {
                this.phone = CashbackCampaingController.getPhone()
                if (this.phone) {
                    this.buttons[1].visible = true
                    this.buttons[0].visible = false
                }
                this.couponsAvailable = CashbackCampaingController.getCouponsAvailable()
                this.$forceUpdate()
            }
        },
        getCampaign: async function () {
            this.cashbackCampaign = await CashbackCampaingController.getStatus()
            if (this.cashbackCampaign.campaignEnabled === 4) {
                this.cashbackCampaignParams = this.cashbackCampaign.campaignParams
            }

            if (!this.cashbackCampaignParams) {
                this.buttons[0].visible = false
                this.buttons[1].visible = true
            }

            if (this.cashbackCampaign.campaignEnabled === 5) {
                this.buttons[0].visible = false
                this.buttons[1].visible = false
            }
        },
        openCoupomCodeModal: function () {
            this.showCoupomCodeModal = true
        },
        closeCoupomCodeModal: function () {
            this.showCoupomCodeModal = false
        },
        selectGift: function (gift) {
            // gift.amount_type = Tipo do desconto {CASH -> Valor, PERCENT -> Porcentagem}
            // gift.amount = valor do desconto
            // gift.type = Tipo do Cupom => {DISCOUNT_ORDER -> Desconto no pedido, FREE_DELIVERY -> Frete grátis, CASHBACK_ACCUMULATE -> Ganho de cashback com % diferente do cashback da campanha}
            this.buttons[1].visible = false
            CashbackCampaingController.setGiftApplied(gift)
            this.calculateGiftValue()
            this.calculateCashback()
            this.closeCoupomCodeModal()
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        removeCoupon: function (key) {
            this.valueDiscount = 0
            CashbackCampaingController.removeGiftApplied(key)
            this.calculateCashback()
            this.calculateGiftValue()
            this.buttons[1].visible = true
        },
        getValueDiscount: function () {
            return this.formatMoney(this.valueDiscount)
        },
        calculateGiftValue: function () {
            // Caso o cupom seja de desconto no pedido, o valor do desconto será calculado com o desconto do cupom
            let valueDiscount = 0
            this.giftsApplied = CashbackCampaingController.getGiftApplied()
            this.giftsApplied.forEach((g) => {
                if (g.type === 'DISCOUNT_ORDER') {
                    if (['CASH', 'CASHBACK'].includes(g.amount_type) || g.is_cashback === 'true' || g.is_cashback === true) {
                        valueDiscount += parseFloat(g.amount)
                    } else if (g.amount_type === 'PERCENT') {
                        let calculatedValue = (parseFloat(g.amount) / 100) * this.saleValue
                        valueDiscount += Math.floor(calculatedValue * 100) / 100
                    }
                } else if (g.type === 'PRODUCT_DISCOUNT') {
                    const productsData = g.products && g.products.data ? g.products.data : g.products
                    const productsArray = Array.isArray(productsData) ? productsData : (productsData ? [productsData] : [])
                    const skus = productsArray.map(p => String(p.sku))

                    let subtotal = 0
                    skus.forEach(sku => {
                        const item = this.cart.find(item => String(item.productCode) === sku)
                        if (item) {
                            subtotal += Math.round(item.totalItemPrice * 100) / 100
                        }
                    })

                    if (g.amount_type === 'PERCENT') {
                        let calculatedValue = (parseFloat(g.amount) / 100) * subtotal
                        valueDiscount += Math.floor(calculatedValue * 100) / 100
                    } else if (['CASH', 'CASHBACK'].includes(g.amount_type)) {
                        valueDiscount += Math.min(parseFloat(g.amount), subtotal)
                    }
                }
            })
            if (valueDiscount >= this.saleValue) {
                valueDiscount = this.saleValue - 1
                this.message = this.getString('desconto_nao_pode_exceder_o_valor_do_pedido')
            } else {
                this.message = ''
            }
            this.valueDiscount = valueDiscount
            CashbackCampaingController.setDiscount(valueDiscount)
            this.calculateCashback()
            this.$forceUpdate()
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        calculateCashback: function () {
            // Caso o cupom seja de cashback acumulado, o valor do cashback será calculado com o desconto do cupom
            if (!this.cashbackCampaignParams) {
                return
            }
            this.valueCashback = 0
            const maxGain = this.cashbackCampaignParams.max_gain ? parseFloat(this.cashbackCampaignParams.max_gain) : 0
            let giftsApplied = CashbackCampaingController.getGiftApplied().filter((g) => g.type === 'CASHBACK_ACCUMULATE')
            if (giftsApplied.length > 0) {
                giftsApplied.forEach((g) => {
                    if (g.type === 'CASHBACK_ACCUMULATE') {
                        this.valueCashback = this.formatToPercentage(g.amount)
                        this.cahsbackAccumulated = true
                    } else {
                        this.cahsbackAccumulated = false
                    }
                })
            } else {
                this.cahsbackAccumulated = false
                let minOrder = parseFloat(this.cashbackCampaignParams.min_order)
                if (this.saleValue >= minOrder) {
                    this.valueCashback = (this.cashbackCampaignParams.percentage / 100) * (this.saleValue - this.valueDiscount)
                    this.valueCashback = this.valueCashback > maxGain ? maxGain : this.valueCashback
                } else {
                    this.valueCashback = 0
                }
            }
        },
        formatToPercentage: function (value) {
            const num = parseFloat(value)
            if (Number.isNaN(num)) {
                return value
            }
            const formatted = Number.isInteger(num)
                ? num.toString()
                : num.toFixed(2)
            return `${formatted}%`
        },

        buildCashbackMessage: function () {
            if (!this.cashbackCampaign) {
                return ''
            }

            if (this.cashbackCampaign.campaignEnabled === 5) {
                if (this.crmFixeResume && this.valueDiscount > 0) {
                    return `<p>Desconto de <strong>${this.formatMoney(this.valueDiscount)}</strong> aplicado</p>`
                }

                if (this.crmFixeClientMessage) {
                    return `<p>${this.crmFixeClientMessage}</p>`
                }
                return `<p>${this.getString('cashback_cpf_cnpj')}</p>`
            }

            if (!this.cashbackCampaignParams) {
                return `<p>${this.getString('tem_um_cupom_utilize_para_garantir_seu_desconto')}</p>`
            }

            let message = ''
            let minOrder = this.cashbackCampaignParams.min_order ? parseFloat(this.cashbackCampaignParams.min_order) : 0
            let percentage = this.cashbackCampaignParams.percentage

            if (minOrder > this.saleValue) {
                message += `<p>${this.getString('ao_comprar_acima_de')} ${this.formatMoney(parseFloat(minOrder))}, ${this.getString('voce_garante')} ${percentage}% ${this.getString('de_cashback_na_proxima_compra')}</p>
                <p>${this.getString('pratico_imediato_e_perfeito_para_economizar_mais')}</p>`
            }
            if (minOrder <= this.saleValue && this.valueCashback > 0 && this.phone) {
                message += `<p>${this.getString('voce_informou_seu_telefone_e_ganhara')} ${this.formatMoney(this.valueCashback)} ${this.getString('de_cashback_na_proxima_compra')}</p>`
            }
            if (this.cahsbackAccumulated) {
                message += `<p>${this.getString('adicionou_um_cupom_de_cashback')} ${this.valueCashback} ${this.getString('de_cashback_na_proxima_compra')}</p>`
            }
            if (minOrder <= this.saleValue && this.valueCashback > 0 && !this.phone) {
                message += `<p>${this.getString('informe_seu_telefone_e_ganhe')} ${this.formatMoney(this.valueCashback)} ${this.getString('na_proxima_compra')}</p>
                <p>${this.getString('rapido_facil_e_com_economia_garantida')}</p>`
            }
            return message
        },
        getGiftCode: function (gift) {
            if (!gift || !gift.gift) {
                return 'CUPOM'
            }
            return gift.gift.gift.code || gift.gift.code || 'CUPOM'
        }
    },
    mounted () {
        this.getCampaign().then(() => {
            this.valueDiscount = CashbackCampaingController.getDiscountApplied().value
            this.calculateGiftValue()
            this.calculateCashback()
        })

        eventModule.$on('crmFixeClientLoading', () => {
            this.loadingCrmFixe = true
            this.crmFixeFinished = false
        })

        eventModule.$on('crmFixeClientLoaded', async (result) => {
            this.crmFixeFinished = true
            setTimeout(() => { this.loadingCrmFixe = false }, 900)
            if (result && !result.success) {
                this.crmFixeClientMessage = result.message || 'Sem pontos disponíveis'
                this.buttons[2].visible = true
                this.buildCashbackMessage()
                this.$forceUpdate()
                return
            }

            this.crmFixeClientMessage = null
            const resume = await CashbackCampaingController.getResume()
            if (!resume) return
            this.crmFixeResume = resume

            const available = parseFloat(resume.valueAvailable) || 0
            const couponVal = parseFloat(resume.couponValue) || 0
            let discount = 0

            if (couponVal > 0 && available > 0) {
                if (this.saleValue > couponVal) {
                    const maxDiscount = Math.min(available, this.saleValue - 1)
                    const fullCoupons = Math.floor(maxDiscount / couponVal)
                    discount = fullCoupons * couponVal
                } else {
                    discount = Math.min(available, this.saleValue - 1)
                }
            } else {
                discount = Math.min(available, this.saleValue - 1)
            }

            this.valueDiscount = discount
            CashbackCampaingController.setDiscount(this.valueDiscount)
            this.buttons[2].visible = true
            this.$forceUpdate()
        })

        eventModule.$on('crmFixeClearData', () => {
            this.clearData(true)
        })

        if (this.giftsApplied.length > 0) {
            this.buttons[1].visible = false
            this.buttons[0].visible = false
        } else if (this.phone) {
            this.buttons[1].visible = true
            this.buttons[0].visible = false
        } else {
            this.buttons[1].visible = false
            this.buttons[0].visible = true
        }
    },
    beforeDestroy () {
        eventModule.$off('crmFixeClientLoaded')
        eventModule.$off('crmFixeClientLoading')
        eventModule.$off('crmFixeClearData')
    }
}
</script>

<style scoped>
.fidelity-card-component {
    background-color: #d9d9d9;
    padding: 20px;
    margin: 0;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    width: auto;

    .red {
        color: red;
    }

    .green {
        color: green;
    }

    h2 {
        font-size: 30px;
        margin-bottom: 20px;
    }

    .content-container {
        margin-bottom: 20px;
        display: grid;
        grid-template-columns: 1.8fr 1fr;
        gap: 40px;
        min-height: 180px;

        .info-container {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .info-item {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
                p {
                    font-size: 30px;
                    margin: 10px 0;
                }
            }
            .applied-coupon-container {
                display: flex;
                flex-direction: row;
                gap: 10px;
                flex-wrap: wrap;
                .applied-coupon-item {
                    display: flex;
                    border: none;
                    padding: 10px;
                    border-radius: 10px;
                    font-size: 25px;
                    align-items: center;
                    justify-content: space-between;
                    background: rgb(0, 148, 0);
                    min-width: 40%;
                    color: white;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                    font-weight: bold;
                    text-transform: uppercase;
                    button {
                        margin-left: 10px;
                        color: white;
                        font-weight: bold;
                        background: rgb(0, 148, 0);
                        border: none;
                        font-size: 25px;
                        padding: 5px 10px;
                        &:before {
                            content: "\2715";
                        }
                    }
                }
            }
            .message-container {
                font-size: 20px;
                color: red;
                text-align: center;
                margin-top: 15px;
                text-transform: uppercase;
            }
        }

        .resume-container {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;

            .resume-item {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                font-size: 25px;

                span:first-of-type {
                    font-weight: bold;
                }
            }
        }

        p {
            font-size: 27px;
        }
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        width: 100%;

        button {
            width: 100%;
            height: 80px;
        }
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 2;
    }

    .loading-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        border-radius: 10px;
        overflow: hidden;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 20px;

        .loading-text {
            font-size: 25px;
            font-weight: bold;
            color: #333;
            text-align: center;
            padding: 0 20px;
        }
    }
}
@media (min-width: 699px) and (max-width: 1025px) {
    .fidelity-card-component {
        padding: 17px;

        h2 {
            font-size: 25px;
            margin-bottom: 17px;
        }

        .content-container {
            margin-bottom: 17px;
            gap: 20px;
            min-height: 153px;
            grid-template-columns: 1.3fr 1fr;

            .info-container {
                .info-item {
                    p {
                        font-size: 24px;
                        margin: 8px 0;
                    }
                }
                .applied-coupon-container {
                    gap: 8px;
                    .applied-coupon-item {
                        padding: 8px;
                        font-size: 21px;
                        button {
                            margin-left: 8px;
                            font-size: 21px;
                            padding: 4px 8px;
                        }
                    }
                }
            }

            .resume-container {
                .resume-item {
                    font-size: 21px;
                }
            }

            p {
                font-size: 23px;
            }
        }

        .button-container {
            gap: 8px;

            button {
                height: 68px;
            }
        }
    }
}

@media (max-width: 698px) {
    .fidelity-card-component {
        padding: 8px;

        h2 {
            font-size: 21px;
            margin-bottom: 14px;
        }

        .content-container {
            margin-bottom: 14px;
            grid-template-columns: 1.3fr 1fr;
            gap: 5px;
            min-height: auto;

            .info-container {
                .info-item {
                    p {
                        font-size: 15px;
                        margin: 5px 0;
                    }
                }
                .applied-coupon-container {
                    gap: 7px;
                    .applied-coupon-item {
                        padding: 7px;
                        font-size: 17px;
                        min-width: auto;
                        button {
                            margin-left: 7px;
                            font-size: 17px;
                            padding: 3px 7px;
                        }
                    }
                }
            }

            .resume-container {
                .resume-item {
                    font-size: 13px;
                    margin: 2px 0;
                }
            }

            p {
                font-size: 19px;
            }
        }

        .button-container {
            flex-direction: column;
            gap: 7px;

            button {
                height: 40px;
            }
        }
    }
}

@media (orientation: landscape) {
    .fidelity-card-component {
        padding: 15px;

        h2 {
            font-size: 23px;
            margin-bottom: 15px;
        }

        .content-container {
            margin-bottom: 15px;
            gap: 30px;
            min-height: 135px;

            .info-container {
                .info-item {
                    p {
                        font-size: 23px;
                        margin: 7px 0;
                    }
                }
                .applied-coupon-container {
                    gap: 7px;
                    .applied-coupon-item {
                        padding: 7px;
                        font-size: 19px;
                        button {
                            margin-left: 7px;
                            font-size: 19px;
                            padding: 4px 7px;
                        }
                    }
                }
            }

            .resume-container {
                .resume-item {
                    font-size: 19px;
                }
            }

            p {
                font-size: 20px;
            }
        }

        .button-container {
            gap: 7px;

            button {
                height: 60px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/FidelityComponents/FidelityCardComponent.vue